/** @jsxImportSource @emotion/react */
import { Divider, IconButton, Theme, useTheme } from '@mui/material';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { StylesClassName, UseStyles } from 'types/styles';
import HomeIcon from 'components/icons/HomeIcon';
import TemplateIcon from 'components/icons/TemplateIcon';
import HelpIcon from 'components/icons/HelpIcon';
import UploadIcon from 'components/icons/UploadIcon';
import { usePaths } from 'hooks/usePaths';
import { FormattedMessage } from 'react-intl';
import { AuthenticatedTemplate } from '@azure/msal-react';

interface IMainNavProps {
  className?: StylesClassName;
}

const MainNav: React.FC<IMainNavProps> = ({ className }) => {
  const theme = useTheme() as Theme;
  const classes = useStyles(theme);
  const paths = usePaths();

  return (
    <nav css={[classes.MainNav, className]}>
      <ul css={classes.list}>
        <li css={classes.item}>
          <NavLink to={paths.home.generate()} css={classes.link}>
            <IconButton css={classes.iconBtn} className="mainNavIcon">
              <HomeIcon />
            </IconButton>
            <span>
              <FormattedMessage id={'MainNav.home'} defaultMessage={'Home'} />
            </span>
          </NavLink>
        </li>
        <Divider css={classes.divider} />
        <li css={classes.item}>
          <NavLink to={paths.templates.generate()} css={classes.link}>
            <IconButton css={classes.iconBtn} className="mainNavIcon">
              <TemplateIcon />
            </IconButton>
            <span>
              <FormattedMessage id={'MainNav.templates'} defaultMessage={'Templates'} />
            </span>
          </NavLink>
        </li>
        <AuthenticatedTemplate>
          <li css={classes.item}>
            <NavLink to={paths.uploads.generate()} css={classes.link}>
              <IconButton css={classes.iconBtn} className="mainNavIcon">
                <UploadIcon />
              </IconButton>
              <span>
                <FormattedMessage id={'MainNav.uploads'} defaultMessage={'Uploads'} />
              </span>
            </NavLink>
          </li>
        </AuthenticatedTemplate>
        <Divider css={classes.divider} />
        {/* <li css={classes.item}>
          <NavLink to={paths.dashboard.generate()} css={classes.link}>
            <IconButton css={classes.iconBtn} className="mainNavIcon">
              <MonitoringIIcon />
            </IconButton>
            <span>
              <FormattedMessage id={'MainNav.dashboard'} defaultMessage={'Dashboard'} />
            </span>
          </NavLink>
        </li>
        <li css={classes.item}>
          <NavLink to={paths.partners.generate()} css={classes.link}>
            <IconButton css={classes.iconBtn} className="mainNavIcon">
              <HandshakeOutlinedIcon />
            </IconButton>
            <span>
              <FormattedMessage id={'MainNav.partners'} defaultMessage={'Partners'} />
            </span>
          </NavLink>
        </li> */}
        <li css={classes.item}>
          <NavLink to={paths.help.generate()} css={classes.link}>
            <IconButton css={classes.iconBtn} className="mainNavIcon">
              <HelpIcon />
            </IconButton>
            <span>
              <FormattedMessage id={'MainNav.help'} defaultMessage={'Help'} />
            </span>
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

const useStyles = (theme: Theme): UseStyles => ({
  MainNav: {},
  list: {
    listStyle: 'none',
    padding: 20,
    margin: 0,
  },
  item: {},
  link: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '10px 20px',
    color: theme.palette.custom.primary.brand[150],
    textDecoration: 'none',
    fontWeight: 500,

    '&:hover, &.active': {
      fontWeight: 700,

      '& .mainNavIcon': {
        backgroundColor: theme.palette.custom.primary.brand[50],
      },
    },
    '&:active': {
      '& .mainNavIcon': {
        backgroundColor: theme.palette.custom.primary.brand[80],
      },
    },
  },
  selected: {
    fontWeight: 700,

    '& .mainNavIcon': {
      backgroundColor: theme.palette.custom.primary.brand[100],
    },
  },
  divider: {
    margin: theme.spacing(2),
  },
  iconBtn: {
    pointerEvents: 'none',
    width: 44,
    height: 44,
    color: theme.palette.custom.primary.brand[150],
  },
});

export default MainNav;
